import instance from './http'
import url from './url'

export default {
  // 绑定员工信息
  setStaffInfo: (params) => instance.post(url.staffInfo, params),
  // 获取员工信息
  getStaffInfo: () => instance.get(url.staffInfo),
}
